<template>
    <div class="brand-selector-modal">
        <Popup :class-name="showPopup ? 'open' : ''" @closePopup="closePopup" :closeable="false">
            <h4 class="popup-title">
                {{ config.title }}
            </h4>
            <div class="popup-content content">
                <v-form @submit.prevent="handleSubmit" ref="form" class="">
                    <div class="form-content">
                        <v-select
                            class="brand-selector"
                            :disabled="items.length == 1"
                            :items="items"
                            label="Brand"
                            v-model="selectedBrand"
                            outline
                            item-text="label"
                            item-value="id"
                            :menu-props="{
                                closeOnContentClick: true
                            }"
                        >
                            <template v-slot:prepend-item v-if="config.allowClear">
                                <v-list-tile ripple @click="selectedBrand = null">
                                    <v-list-tile-content>
                                        <v-list-tile-title>Clear</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                        </v-select>

                        <template v-if="canSetCustomDate">
                            <div class="mb-3"></div>
                            <v-menu
                                ref="datePickerMenu"
                                v-model="datePickerMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="selectedDate"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        color="#5db599"
                                        v-model="selectedDate"
                                        label="Starting Date"
                                        readonly
                                        :disabled="useLaunchDate"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker 
                                    color="#5db599" 
                                    :disabled="useLaunchDate" 
                                    :max="maxDate" 
                                    v-model="selectedDate" 
                                    no-title 
                                    scrollable >
                                    <v-spacer></v-spacer>
                                    <v-btn flat color="secondary" @click="datePickerMenu = false">Cancel</v-btn>
                                    <v-btn flat color="#5db599" @click="$refs.datePickerMenu.save(selectedDate)">OK</v-btn>
                                </v-date-picker>
                            </v-menu>
                            <v-checkbox
                                v-model="useLaunchDate"
                                color="#5db599"
                                label="Use market launch date"
                            />
                        </template>

                    </div>

                    <div class="buttons vertical">
                        <v-btn type="submit" class="popup-btn" :disabled="!config.allowClear && selectedBrand == null" >{{ "SAVE" }}</v-btn>
                        <v-btn type="button" class="popup-btn secondary" @click="cancelPopup"
                            >CANCEL</v-btn
                        >
                    </div>
                </v-form>
            </div>
        </Popup>
    </div>
</template>

<script>
import Popup from "../../../common/Popup.vue";

export default {
    components: {
        Popup
    },
    props: {
        config:{
            type: Object,
        }
    },
    data() {
        return {
            showPopup: true,
            selectedBrand: null,
            selectedDate: null,
            maxDate: null,
            datePickerMenu: false,
            useLaunchDate: false,
            canSetCustomDate: false,
            items: [],
        };
    },
    mounted() {
        this.items = this.config.brands;
        this.selectedBrand = this.config.initialSelectedBrand;
        if(this.items.length == 1){
            this.selectedBrand = this.items[0]['id'];
        }

        this.useLaunchDate = this.config.initialUseLaunchDate;
        this.canSetCustomDate = this.config.canSetCustomDate;
        
        if(this.config.initialDate != null && this.canSetCustomDate) {
            this.selectedDate = this.config.initialDate;
        }else{
            this.selectedDate = null;
        }
       
        this.maxDate = new Date().toISOString().substring(0, 10);
    },
    watch:{
        selectedBrand(newVal){
            if(newVal != null && this.canSetCustomDate && this.useLaunchDate){
                this.selectedDate = this.items.find((e)=>e.id == newVal).market_launch_date;
            }
        }
    },
    methods: {
        async handleSubmit() {
            this.$emit("save", this.selectedBrand, this.useLaunchDate || !this.canSetCustomDate ? null : this.selectedDate);
            this.closePopup();
        },
        closePopup() {
            this.showPopup = !this.showPopup;
            this.$emit("close");
        }, 
        cancelPopup() {
            this.showPopup = !this.showPopup;
            this.$emit("cancel");
        },
    }
};
</script>

<style lang="scss"></style>
